__turbopack_context__.v({
  "icon": "Icon-module__REVIaG__icon",
});
